import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import "../assets/Css/checkout.css";
import { Form } from "antd";
import Input from "antd/es/input/Input";
import {
  iwrapper,
  googlepay,
  paypal,
  mastercard,
  shopdetail,
  carddetail,
  apppay,
} from "../Constant/Index";
import { Link } from "react-router-dom";

const Checkout = () => {
  const [addresses, setAddresses] = useState([
    {
      id: "home",
      label: "My Home",
      address: "4806 Fittro Street Hughes, Victoria Street Morton Grove",
      city: "Ottawa, IL 61350",
    },
    {
      id: "office",
      label: "My Office",
      address: "4806 Fittro Street Hughes, Victoria Street Morton Grove",
      city: "Ottawa, IL 61350",
    },
  ]);

  const [selectedAddress, setSelectedAddress] = useState(addresses[0].id);

  const handleAddressChange = (addressId) => {
    setSelectedAddress(addressId);
  };

  const addNewAddress = () => {
    const newAddress = {
      id: `address-${addresses.length + 1}`,
      label: `New Address ${addresses.length + 1}`,
      address: "1234 New Street, Example Town",
      city: "Sample City, SC 12345",
    };
    setAddresses([...addresses, newAddress]);
    setSelectedAddress(newAddress.id);
  };

  const [selectedOption, setSelectedOption] = useState("");

  const paymentOptions = [
    { id: "googlepay", name: "Google Pay", img: googlepay, className: "gpay" },
    { id: "paypal", name: "PayPal", img: paypal, className: "paypal" },
    {
      id: "mastercard",
      name: "Mastercard",
      img: mastercard,
      className: "master",
    },
    {
      id: "apppay",
      name: "App Pay",
      img: apppay,
      className: "apppay",
    },
  ];
  const summaryitems = [
    {
      name: "Magnesium Salt",
      quantity: 5,
      price: "$500.00",
      imgSrc: shopdetail,
    },
    {
      name: "Magnesium Salt",
      quantity: 1,
      price: "$500.00",
      imgSrc: carddetail,
    },
    {
      name: "Magnesium Salt",
      quantity: 7,
      price: "$500.00",
      imgSrc: shopdetail,
    },
  ];
  const totals = [
    { label: "Tax", amount: "£5.00" },
    { label: "Estimated Shipping Cost", amount: "£20.00" },
    { label: "Promo Applied", amount: "-£10.00" },
    { label: "Order Total", amount: "£300.00", isTotal: true },
  ];
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  return (
    <>
      <Header />
      <PageHeader pagename="Checkout" />
      <section className="checkout-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div class="slider-heading product-contant">
                <h2 class="primary-color">shipping Details</h2>
              </div>
              <div className="row">
                {addresses.map((address) => (
                  <div className="col-lg-6 mt-4" key={address.id}>
                    <label
                      className={`card ${
                        selectedAddress === address.id ? "active" : ""
                      }`}
                      onClick={() => handleAddressChange(address.id)}
                    >
                      <div className="position-address">
                        <input
                          name="plan"
                          className="radio"
                          type="radio"
                          checked={selectedAddress === address.id}
                          onChange={() => handleAddressChange(address.id)}
                        />
                        <span className="radio-custom"></span>
                      </div>
                      <span className="plan-details">
                        <div className="social-office-content">
                          <h4>{address.label}</h4>
                        </div>
                        <p>{address.address}</p>
                        <h5 className="ottawa">{address.city}</h5>
                      </span>
                    </label>
                  </div>
                ))}
                {/* <div className="col-lg-4 mt-4">
									<div className="add-radio-new-address">
										<button onClick={addNewAddress} className="btn btn-link">
											<div className="add-new-addresss-img-heading">
												<div className="address-icon">
													<i class="fa-solid fa-plus"></i>
												</div>
												<h4>Add New Address</h4>
											</div>
										</button>
									</div>
								</div> */}
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div class="slider-heading product-contant mt-4">
                    <h2 class="primary-color">
                      Personal & Additional Information
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="contact-form">
                    <Form>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input-dv">
                            <Input type="text" placeholder="First Name" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-dv">
                            <Input type="text" placeholder="Last Name" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-dv">
                            <Input
                              type="text"
                              placeholder="Company Name (Optional)"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="email" placeholder="Email Address" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="number" placeholder="Contact Number" />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-dv">
                            <Input type="text" placeholder="Address Line" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="text" placeholder="Country" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="text" placeholder="City" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="text" placeholder="State" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="text" placeholder="Post Code" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div class="slider-heading product-contant mt-4">
                            <h2 class="primary-color">Delivery Option</h2>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-dv">
                            <select className="custom-select">
                              <option value="" disabled selected>
                                Select Country
                              </option>
                              {/* Add country options here */}
                              <option value="usa">USA</option>
                              <option value="canada">Canada</option>
                              <option value="uk">UK</option>
                              {/* Add more options as needed */}
                            </select>
                            <div className="select-icon">
                              <i class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <select className="custom-select">
                              <option value="" disabled selected>
                                Select Delivery Option
                              </option>
                              {/* Add delivery options here */}
                              <option value="standard">Standard</option>
                              <option value="express">Express</option>
                              <option value="overnight">Overnight</option>
                              {/* Add more options as needed */}
                            </select>
                            <div className="select-icon">
                              <i class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="i-content">
                    <img src={iwrapper} className="img-fluid" alt="" />
                    <div className="wrapper">
                      <p>
                        United Kingdom - £4.99 (2-3 day delivery ) Free delivery
                        on order over £100 <br />
                        Republic of Ireland- £19.90 ( Two day delivery ) <br />{" "}
                        Europe - £29.90 ( 5 day delivery)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div class="slider-heading product-contant mt-4">
                    <h2 class="primary-color">Payment Option</h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="radio-payment-btn">
                    {paymentOptions.map((option) => (
                      <div
                        className={`btn-payment-radio ${option.className}`}
                        key={option.id}
                      >
                        <input
                          id={option.id}
                          name="plan"
                          className="radio"
                          type="radio"
                          checked={selectedOption === option.id}
                          onChange={() => setSelectedOption(option.id)}
                        />
                        <label htmlFor={option.id}>
                          <img
                            src={option.img}
                            className="img-fluid"
                            alt={option.name}
                          />
                        </label>
                        <span
                          className={`radio-custom ${
                            selectedOption === option.id ? "selected" : ""
                          }`}
                        ></span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="contact-form">
                    <Form>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div className="input-dv">
                            <Input
                              type="number"
                              placeholder="Enter Card Number"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="number" placeholder="Expiry Date" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-dv">
                            <Input type="text" placeholder="CVV" />
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="order-summary">
                <div class="slider-heading product-contant">
                  <h2 class="primary-color">Order Summary</h2>
                </div>
                <table>
                  <tbody>
                    {summaryitems.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <img src={item.imgSrc} alt="" className="img-fluid" />
                        </td>
                        <td>{item.name}</td>
                        <td>QTY:{item.quantity}</td>
                        <td>{item.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="order-summery-promo-code">
                <div className="promo-wrapper">
                  <Input type="text" placeholder="Enter Promo Code" />
                  <Link
                    style={{
                      borderRadius: "0px 5px 5px 0px",
                    }}
                    to="/"
                    className="btn-all"
                  >
                    Apply Promo
                  </Link>
                </div>
              </div>
              <div className="total-summary-main">
                <ul className="main-total-content">
                  {totals.map((total, index) => (
                    <li
                      key={index}
                      className={total.isTotal ? "total-last" : ""}
                    >
                      <h4>{total.label}</h4>
                      <h4>{total.amount}</h4>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex align-items-center justify-content-between mt-3 border-top pt-3">
                <div>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkmark"></span>
                    Nam massa dolor, imperdiet sed ante eget, luctus gravida
                    ipsum lobortis eu. Donec id.
                  </label>
                </div>
                <Link className="btn-all checkout-submit" to="/Thankyou">
                  Submit
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Checkout;
